// import React, { useEffect, useState } from "react";
// import { Button, Container, Row } from "react-bootstrap";
// import {
//   Egame,
//   Evolution,
//   Fastspin,
//   Fc,
//   GTF,
//   HorseBook,
//   iloveyou,
//   JDB,
//   Jili,
//   Joker,
//   KINGMAKER,
//   PP,
//   PT,
//   Sexy,
//   Spade,
//   Spribe,
// } from "./CasinoFile";
// import InnerCasinControl from "../components/InnerCasinControl";
// import { apiGet, apiPost, apiPut } from "../utils/apiFetch";
// import apiPath from "../utils/apiPath";
// import { useParams } from "react-router-dom";
// const CasinoControl = () => {
//   const parmas = useParams();
//   const addStatus = (array) => {
//     return array?.map((res) => {
//       return { ...res, status: "off" };
//     });
//   };
//   const [provider, setProvider] = useState(addStatus(list));
//   const [show, setShow] = useState([]);
//   const [object, setObject] = useState({
//     Evolution: addStatus(Evolution),
//     Egame: addStatus(Egame),
//     FC: addStatus(Fc),
//     Fastspin: addStatus(Fastspin),
//     GTF: addStatus(GTF),
//     HorseBook: addStatus(HorseBook),
//     iloveyou: addStatus(iloveyou),
//     JDB: addStatus(JDB),
//     Jili: addStatus(Jili),
//     Joker: addStatus(Joker),
//     KINGMAKER: addStatus(KINGMAKER),
//     Sexy: addStatus(Sexy),
//     PP: addStatus(PP),
//     PT: addStatus(PT),
//     Spade: addStatus(Spade),
//     Spribe: addStatus(Spribe),
//   });

//   const onChangeShow = (id) => {
//     if (show.includes(id)) {
//       setShow((prev) => {
//         return prev?.filter((res) => {
//           return res !== id;
//         });
//       });
//     } else {
//       setShow([...show, id]);
//     }
//   };

//   const updateCasinoStatus = async (obj) => {
//     setObject((prev) => {
//       return {
//         ...prev,
//         [obj?.title]: prev[obj?.title]?.map((res) => {
//           if (res?.gameCode == obj?.gameCode) {
//             return { ...res, status: obj?.status };
//           } else {
//             return res;
//           }
//         }),
//       };
//     });
//   };
//   function convertArrayToObject(array) {
//     return array.reduce((acc, game) => {
//       acc[game.gameCode] = game;
//       return acc;
//     }, {});
//   }
//   const onSubmit = async () => {
//     let Game = {
//       Evolution: convertArrayToObject(object?.Evolution),
//       Egame: convertArrayToObject(object?.Egame),
//       FC: convertArrayToObject(object?.FC),
//       Fastspin: convertArrayToObject(object?.Fastspin),
//       GTF: convertArrayToObject(object?.GTF),
//       HorseBook: convertArrayToObject(object?.HorseBook),
//       [`I LOVE U`]: convertArrayToObject(object?.iloveyou),
//       JDB: convertArrayToObject(object?.JDB),
//       Jili: convertArrayToObject(object?.Jili),
//       Joker: convertArrayToObject(object?.Joker),
//       KINGMAKER: convertArrayToObject(object?.KINGMAKER),
//       Sexy: convertArrayToObject(object?.Sexy),
//       PP: convertArrayToObject(object?.PP),
//       PT: convertArrayToObject(object?.PT),
//       Spade: convertArrayToObject(object?.Spade),
//       Spribe: convertArrayToObject(object?.Spribe),
//     };
//     let Provider = provider.reduce((acc, game) => {
//       acc[game.key] = game;
//       return acc;
//     }, {});
//     const { status, data: response_users } = await apiPost(
//       apiPath.casinoControl,
//       {
//         userId: parmas?.id,
//         userType: parmas?.type,
//         result: { Game: Game, Provider: Provider },
//       }
//     );
//     if (status === 200) {
//       if (response_users.success) {
//         getData();
//       }
//     }
//   };

//   const getData = async () => {
//     const { status, data: response_users } = await apiGet(
//       apiPath.getcasinoControl,
//       {
//         userId: parmas?.id,
//         userType: parmas?.type,
//       }
//     );
//     if (status === 200) {
//       if (response_users.success) {
//         let result = response_users?.results?.providers;
//         if (result?.length > 0) {
//           setProvider((prev) => {
//             return prev?.map((item) => {
//               let check = result?.find((res) => {
//                return res?.name == item?.key;
//               })?.isBlocked;
//               return { ...item, status: check ? "on" : "off" };
//             });
//           });
//           let ObjEvolution = result?.find(
//             (res) => res?.name == "Evolution"
//           )?.games;
//           let ObjEgame = result?.find((res) => res?.name == "Egame")?.games;
//           let ObjFc = result?.find((res) => res?.name == "FC")?.games;
//           let ObjFastspin = result?.find(
//             (res) => res?.name == "Fastspin"
//           )?.games;
//           let ObjGTF = result?.find((res) => res?.name == "GTF")?.games;
//           let ObjHorseBook = result?.find(
//             (res) => res?.name == "HorseBook"
//           )?.games;
//           let Objiloveyou = result?.find(
//             (res) => res?.name == "I LOVE U"
//           )?.games;

//           let ObjJDB = result?.find((res) => res?.name == "JDB")?.games;
//           let ObjJili = result?.find((res) => res?.name == "Jili")?.games;
//           let ObjJoker = result?.find((res) => res?.name == "Joker")?.games;
//           let ObjKINGMAKER = result?.find(
//             (res) => res?.name == "KINGMAKER"
//           )?.games;
//           let ObjSexy = result?.find((res) => res?.name == "Sexy")?.games;
//           let ObjPP = result?.find((res) => res?.name == "PP")?.games;
//           let ObjPT = result?.find((res) => res?.name == "PT")?.games;
//           let ObjSpade = result?.find((res) => res?.name == "Spade")?.games;
//           let ObjSpribe = result?.find((res) => res?.name == "Spribe")?.games;
//           setObject((prev) => {
//             return {
//               ...prev,
//               Evolution:
//                 ObjEvolution?.length > 0 ? ObjEvolution : prev?.Evolution,
//               Egame: ObjEgame?.length > 0 ? ObjEgame : prev?.Egame,
//               FC: ObjFc?.length > 0 ? ObjFc : prev?.FC,
//               Fastspin: ObjFastspin?.length > 0 ? ObjFastspin : prev?.Fastspin,
//               GTF: ObjGTF?.length > 0 ? ObjGTF : prev?.GTF,
//               HorseBook:
//                 ObjHorseBook?.length > 0 ? ObjHorseBook : prev?.HorseBook,
//               iloveyou: Objiloveyou?.length > 0 ? Objiloveyou : prev?.iloveyou,
//               JDB: ObjJDB?.length > 0 ? ObjJDB : prev?.JDB,
//               Jili: ObjJili?.length > 0 ? ObjJili : prev?.Jili,
//               Joker: ObjJoker?.length > 0 ? ObjJoker : prev?.Joker,
//               KINGMAKER:
//                 ObjKINGMAKER?.length > 0 ? ObjKINGMAKER : prev?.KINGMAKER,
//               Sexy: ObjSexy?.length > 0 ? ObjSexy : prev?.Sexy,
//               PP: ObjPP?.length > 0 ? ObjPP : prev?.PP,
//               PT: ObjPT?.length > 0 ? ObjPT : prev?.PT,
//               Spade: ObjSpade?.length > 0 ? ObjSpade : prev?.Spade,
//               Spribe: ObjSpribe?.length > 0 ? ObjSpribe : prev?.Spribe,
//             };
//           });

//         }
//       }
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   return (
//     <section className="find-member-sec">
//       <Container fluid>
//         <Row className="mb-md-0 mb-3 p-3">
//           <div className="casino-control-outer">
//             <p>Providers -</p>
//             <div className="casino-control">
//               {provider?.map((res) => {
//                 let checked = res?.status == "on";
//                 return (
//                   <div>
//                     <span>{res?.label}</span>
//                     <input
//                       key={res?.label}
//                       name={res?.label}
//                       checked={checked}
//                       onClick={(e) =>
//                         setProvider((prev) => {
//                           return prev?.map((item) => {
//                             if (res?.key == item?.key) {
//                               return {
//                                 ...item,
//                                 status: checked ? "off" : "on",
//                               };
//                             } else {
//                               return item;
//                             }
//                           });
//                         })
//                       }
//                       type="radio"
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </Row>
//         <Row className="mb-md-0 mb-3 p-3">
//           <div className="casino-control-outer">
//             <p>Casino Control -</p>
//             <InnerCasinControl
//               title={"Evolution"}
//               data={object?.Evolution}
//               show={show.includes(0)}
//               setShow={onChangeShow}
//               index={0}
//               updateCasinoStatus={updateCasinoStatus}
//             />
//             <InnerCasinControl
//               title={"FC"}
//               data={object?.FC}
//               show={show.includes(1)}
//               setShow={onChangeShow}
//               index={1}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Fastspin"}
//               data={object?.Fastspin}
//               show={show.includes(2)}
//               setShow={onChangeShow}
//               index={2}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"GTF"}
//               data={object?.GTF}
//               show={show.includes(3)}
//               setShow={onChangeShow}
//               index={3}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"HorseBook"}
//               data={object?.HorseBook}
//               show={show.includes(4)}
//               setShow={onChangeShow}
//               index={4}
//               updateCasinoStatus={updateCasinoStatus}
//             />
//             <InnerCasinControl
//               title={"iloveyou"}
//               data={object?.iloveyou}
//               show={show.includes(5)}
//               setShow={onChangeShow}
//               index={5}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"JDB"}
//               data={object?.JDB}
//               show={show.includes(6)}
//               setShow={onChangeShow}
//               index={6}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Jili"}
//               data={object?.Jili}
//               show={show.includes(7)}
//               setShow={onChangeShow}
//               index={7}
//               updateCasinoStatus={updateCasinoStatus}
//             />
//             <InnerCasinControl
//               title={"Joker"}
//               data={object?.Joker}
//               show={show.includes(8)}
//               setShow={onChangeShow}
//               index={8}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"KINGMAKER"}
//               data={object?.KINGMAKER}
//               show={show.includes(9)}
//               setShow={onChangeShow}
//               index={9}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Sexy"}
//               data={object?.Sexy}
//               show={show.includes(10)}
//               setShow={onChangeShow}
//               index={10}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"PP"}
//               data={object?.PP}
//               show={show.includes(11)}
//               setShow={onChangeShow}
//               index={11}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"PT"}
//               data={object?.PT}
//               show={show.includes(12)}
//               setShow={onChangeShow}
//               index={12}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Spade"}
//               data={object?.Spade}
//               show={show.includes(13)}
//               setShow={onChangeShow}
//               index={13}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Spribe"}
//               data={object?.Spribe}
//               show={show.includes(14)}
//               setShow={onChangeShow}
//               index={14}
//               updateCasinoStatus={updateCasinoStatus}
//             />{" "}
//             <InnerCasinControl
//               title={"Egame"}
//               data={object?.Egame}
//               show={show.includes(15)}
//               setShow={onChangeShow}
//               index={15}
//               updateCasinoStatus={updateCasinoStatus}
//             />
//           </div>
//         </Row>{" "}
//         <div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-start",
//             }}
//           >
//             <Button className="green-btn" onClick={() => onSubmit()}>
//               Submit
//             </Button>
//           </div>
//         </div>
//       </Container>
//     </section>
//   );
// };

// export default CasinoControl;

// const list = [
//   { label: "Indian Poker", key: "Poker" },
//   { label: "Evolution", key: "Evolution" },
//   { label: "Fastspin", key: "Fastspin" },
//   { label: "FC", key: "FC" },
//   { label: "GTF", key: "GTF" },
//   { label: "HorseBook", key: "HorseBook" },
//   { label: "I LOVE U", key: "I LOVE U" },
//   { label: "JDB", key: "JDB" },
//   { label: "Jili", key: "Jili" },
//   { label: "Joker", key: "Joker" },
//   { label: "KINGMAKER", key: "KINGMAKER" },
//   { label: "Sexy", key: "Sexy" },
//   { label: "PP", key: "PP" },
//   { label: "PT", key: "PT" },
//   { label: "Spade", key: "Spade" },
//   { label: "Spribe", key: "Spribe" },
//   { label: "Egame", key: "Egame" },
// ];

import React, { useEffect, useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import {
  Egame,
  Evolution,
  Fastspin,
  Fc,
  GTF,
  HorseBook,
  iloveyou,
  JDB,
  Jili,
  Joker,
  KINGMAKER,
  PP,
  PT,
  Sexy,
  Spade,
  Spribe,
} from "./CasinoFile";
import InnerCasinControl from "../components/InnerCasinControl";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { useParams } from "react-router-dom";

/* ================= CONFIG ================= */

const PROVIDERS = [
  { label: "Indian Poker", key: "Poker" },
  { label: "Evolution", key: "Evolution" },
  { label: "Fastspin", key: "Fastspin" },
  { label: "FC", key: "FC" },
  { label: "GTF", key: "GTF" },
  { label: "HorseBook", key: "HorseBook" },
  { label: "I LOVE U", key: "iloveyou", apiKey: "I LOVE U" },
  { label: "JDB", key: "JDB" },
  { label: "Jili", key: "Jili" },
  { label: "Joker", key: "Joker" },
  { label: "KINGMAKER", key: "KINGMAKER" },
  { label: "Sexy", key: "Sexy" },
  { label: "PP", key: "PP" },
  { label: "PT", key: "PT" },
  { label: "Spade", key: "Spade" },
  { label: "Spribe", key: "Spribe" },
  { label: "Egame", key: "Egame" },
];

/* ================= UTILS ================= */

const addStatus = (arr) => arr?.map((i) => ({ ...i, status: "off" }));

const arrayToObject = (arr) =>
  arr.reduce((acc, item) => {
    acc[item.gameCode] = item;
    return acc;
  }, {});

/* ================= COMPONENT ================= */

const CasinoControl = () => {
  const params = useParams();

  const [providers, setProviders] = useState(
    PROVIDERS.map((p) => ({ ...p, status: "off" }))
  );

  const [games, setGames] = useState({
    Evolution: addStatus(Evolution),
    Egame: addStatus(Egame),
    FC: addStatus(Fc),
    Fastspin: addStatus(Fastspin),
    GTF: addStatus(GTF),
    HorseBook: addStatus(HorseBook),
    iloveyou: addStatus(iloveyou),
    JDB: addStatus(JDB),
    Jili: addStatus(Jili),
    Joker: addStatus(Joker),
    KINGMAKER: addStatus(KINGMAKER),
    Sexy: addStatus(Sexy),
    PP: addStatus(PP),
    PT: addStatus(PT),
    Spade: addStatus(Spade),
    Spribe: addStatus(Spribe),
  });

  const [openIndex, setOpenIndex] = useState([]);

  /* ================= HANDLERS ================= */

  const toggleOpen = (i) => {
    setOpenIndex((prev) =>
      prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]
    );
  };

  const updateCasinoStatus = ({ title, gameCode, status }) => {
    setGames((prev) => ({
      ...prev,
      [title]: prev[title].map((g) =>
        g.gameCode === gameCode ? { ...g, status } : g
      ),
    }));
  };

  /* ================= API ================= */

  const onSubmit = async () => {
    const Game = {};
    PROVIDERS.forEach(({ key, apiKey }) => {
      if (games[key]) {
        Game[apiKey || key] = arrayToObject(games[key]);
      }
    });

    const Provider = providers.reduce((acc, p) => {
      acc[p.key] = p;
      return acc;
    }, {});

    await apiPost(apiPath.casinoControl, {
      userId: params.id,
      userType: params.type,
      result: { Game, Provider },
    });

    getData();
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getcasinoControl, {
      userId: params.id,
      userType: params.type,
    });

    if (status !== 200 || !data?.success) return;

    const providerData = data?.results?.providers;

    if (providerData?.length > 0) {
      setProviders((prev) =>
        prev.map((p) => {
          const found = providerData.find(
            (x) => x.name === (p.apiKey || p.key)
          );
          return { ...p, status: found?.isBlocked ? "on" : "off" };
        })
      );

      setGames((prev) => {
        const updated = { ...prev };
        providerData.forEach((p) => {
          const key = PROVIDERS.find(
            (x) => x.key === p.name || x.apiKey === p.name
          )?.key;
          if (key && p.games?.length) updated[key] = p.games;
        });
        return updated;
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  /* ================= UI ================= */

  return (
    <section className="find-member-sec">
      <Container fluid>
        {/* PROVIDERS */}
        <Row className="p-3">
          <div className="casino-control-outer">
            <p>Providers -</p>
            <div className="casino-control">
              {providers.map((p) => (
                <div key={p.key}>
                  <span>{p.label}</span>
                  <input
                    type="checkbox"
                    checked={p.status === "on"}
                    onChange={() =>
                      setProviders((prev) =>
                        prev.map((x) =>
                          x.key === p.key
                            ? {
                                ...x,
                                status: x.status === "on" ? "off" : "on",
                              }
                            : x
                        )
                      )
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </Row>

        {/* CASINO CONTROL */}
        <Row className="p-3">
          <div className="casino-control-outer">
            <p>Casino Control -</p>

            {PROVIDERS.map((p, i) =>
              games[p.key] ? (
                <InnerCasinControl
                  key={p.key}
                  title={p.key}
                  data={games[p.key]}
                  show={openIndex.includes(i)}
                  setShow={() => toggleOpen(i)}
                  index={i}
                  updateCasinoStatus={updateCasinoStatus}
                />
              ) : null
            )}
          </div>
        </Row>

        {/* SUBMIT */}
        <div className="p-3">
          <Button className="green-btn" onClick={onSubmit}>
            Submit
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default CasinoControl;
